import React from 'react';
import { useController } from 'react-hook-form';
import { TextField } from '@mui/material';
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";

export const TextFieldRequired = ({
    control,
    label,
    name,
    required = true, // Puedes pasar el valor de "required" a través de las propiedades ahora
    customErrorMessages = {},
    type = 'text',
    defaultValue = null,
    isEmpresaPrueba = false,
    ...rest
}) => {
    const { t, i18n } = useTranslation()

    const {
        field: { ref, ...inputProps },
        fieldState: { error },
    } = useController({
        name,
        control,
        defaultValue: defaultValue ? defaultValue : "",
        rules: {
            required: required && {
                value: true,
                message: customErrorMessages.required || t("login.requiredDefault"),
            },
        },
    })

    return (
        <TextField
            label={"* "+label}
            inputRef={ref}
            type={type}
            error={!!error}
            helperText={error?.message}
            InputLabelProps={{ shrink: !!inputProps.value }}
            {...inputProps}
            {...rest}

            sx={{
                '& fieldset': {
                  backgroundColor: isEmpresaPrueba && "#c9c6c6",
                },
                width: '100%'
            }}
        // autoComplete='off'
        />
    );
};
